export const PRIVATE_MENU_ITEMS = {
  DOWNLOAD: "download",
  API: "api",
};
